import React from 'react';

import { withLabelTokenParsing } from '../common/Content.jsx';
import * as _Signature from '../common/Signature.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

const Signature = withLabelTokenParsing(
    _Signature.Component,
    (props, keyword, options) => {
        const data = props.data || {};
        let replaceString = '';
        switch (keyword) {
            case Token.CompanyName:
                if (data.IsSender && data.Gallery && !Utilities.isNullOrWhitespace(data.Gallery.Company)) {
                    replaceString = Token.getReplacementString(data.Gallery.Company, options);
                }
                break;
            case Token.Date:
                replaceString = Token.getReplacementString(data.Date, options);
                break;
            case Token.RecipientName:
                if (!Utilities.isNullOrWhitespace(data.RecipientName)) {
                    replaceString = Token.getReplacementString(data.RecipientName, options);
                }
                break;
            case Token.SenderName:
                if (!Utilities.isNullOrWhitespace(data.SenderName)) {
                    replaceString = Token.getReplacementString(data.SenderName, options);
                }
                break;
            default:
                replaceString = undefined;
                break;
        }
        return replaceString;
    },
    { allowEmptyContent: true }
);
const Tokens = () => [
    Token.getWrappedTokenConfig('Date', Token.Date),
    Token.getWrappedTokenConfig('Recipient Name', Token.RecipientName),
    Token.getWrappedTokenConfig('Sender Name', Token.SenderName),
    Token.getWrappedTokenConfig('Sender Company', Token.CompanyName)
];

const TypeConfig = {
    panel: {
        block: _Signature.TypeConfig.panel.block,
        description: () => _Signature.TypeConfig.panel.description(Utilities.wrapTextForEditor({ text: `{${Token.RecipientName}("before":"","after":"")}`, token: Token.RecipientName })),
        label: _Signature.TypeConfig.panel.label,
        style: _Signature.TypeConfig.panel.style,
        value: () => _Signature.TypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":"","after":"")}`, token: Token.Date }))
    }
}

export {
    Signature as Component,
    Tokens,
    TypeConfig
};